import { Box, ListItem, Typography, useTheme } from '@mui/material';

import { ExternalLinkIcon } from '../icons';
import { ListItemCard } from '../list-item-card.component';

export interface ExternalLinkListItemProps {
  title: string;
  description?: string;
  href: string;
  ariaLabel?: string;
  onOpen?: (url: string) => void;
}

export const ExternalLinkListItem = (props: ExternalLinkListItemProps) => {
  const theme = useTheme();

  return (
    <ListItem disablePadding>
      <ListItemCard
        href={props.href}
        onClick={() => props.onOpen?.(props.href)}
        data-eventid="external-link-site"
        primaryText={
          <Typography variant="subtitle1">{props.title ?? ''}</Typography>
        }
        secondaryText={props.description}
        ariaLabel={props.ariaLabel}
        endAdornment={
          <Box
            sx={{
              position: 'relative',
              width: theme.spacing(2),
              height: theme.spacing(2),
              top: theme.spacing(-0.5),
              right: theme.spacing(1),
            }}
          >
            <ExternalLinkIcon stroke={theme.palette.text.secondary} />
          </Box>
        }
      />
    </ListItem>
  );
};
